var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WaveDownBG',[_vm._t("navigation"),_c('Header',_vm._b({attrs:{"type":"small"}},'Header',_vm.data,false))],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }